import React, { useState } from "react";
import {
  consumeApi,
  getTokens,
  setLiteral,
  validateEmail,
  setLiteral2,
  setLiteral3,
} from "../js/helpers.js";
import Framework7, { Dom7, getDevice } from "framework7";
import { capital, specialChar, digit } from "../js/password.js";
import "../css/passwordChange.css";
import {
  Page,
  f7,
  Navbar,
  Link,
  LoginScreen,
  Block,
  NavRight,
  Button,
  Row,
  Col,
  LoginScreenTitle,
  List,
  ListInput,
} from "framework7-react";

import packageJson from "../../package.json";

export default class changePass extends React.Component {
  render() {
    return (
      /*-----------------------------Cambio de contraseña------------------------------------------*/
      <Page name="home" className="mainImg">
        <LoginScreen className="LOGIN3" opened={true}>
          <Navbar id="NavReg" transparent={true}>
            <NavRight>
              <Link href="/">X</Link>
            </NavRight>
          </Navbar>
          <LoginScreenTitle className="MC">
            {/* Bienvenido a <a>MI CUOTA FÁCIL</a> */}
            {/* <h3 id=''>OLVIDÉ MI CONTRASEÑA</h3> */}
            <h3>{setLiteral(this.state.lsLiterales, 101031)}</h3>
          </LoginScreenTitle>
          <List noHairlinesMd className="containerR2">
            <Row className="aligner2">
              <Col
                width="90"
                xlarge="95"
                large="65"
                medium="65"
                small="90"
                xsmall="90"
              >
                <ListInput
                  className="inputCustom"
                  outline
                  label={setLiteral(this.state.lsLiterales, 101036)}
                  placeholder={setLiteral3(this.state.lsLiterales, 101036)}
                  type="text"
                  autocomplete="false"
                  value={this.state.username}
                  onChange={(e) => this.setState({ username: e.target.value })}
                ></ListInput>
              </Col>
              <Col width="10"></Col>
            </Row>
            <Row className="aligner2">
              <Col
                width="90"
                xlarge="95"
                large="65"
                medium="65"
                small="90"
                xsmall="90"
              >
                <ListInput
                  className="inputCustom2"
                  outline
                  label={setLiteral(this.state.lsLiterales, 101037)}
                  placeholder={setLiteral3(this.state.lsLiterales, 101037)}
                  onChange={this.validatePassword}
                  type="password"
                  name="password"
                ></ListInput>
                <Col width="5">
                  <Button
                    id="btnShowPassRegister"
                    iconF7="eye_slash"
                    size="5"
                    onClick={() =>
                      this.showPassword("password", "btnShowPassRegister")
                    }
                  ></Button>
                </Col>
              </Col>
            </Row>

            <Row className="aligner4">
              <Col id="charactes" width="33.33">
                {setLiteral(this.state.lsLiterales, 101033)}
              </Col>
              <Col id="capital" width="33.33">
                {setLiteral(this.state.lsLiterales, 101034)}
              </Col>
              <Col id="number" width="33.33">
                {setLiteral(this.state.lsLiterales, 101035)}
              </Col>
            </Row>

            <Row className="aligner2">
              <Col
                width="90"
                xlarge="95"
                large="65"
                medium="65"
                small="90"
                xsmall="90"
              >
                <ListInput
                  className="inputCustom"
                  outline
                  label={setLiteral(this.state.lsLiterales, 101039)}
                  placeholder={setLiteral3(this.state.lsLiterales, 101039)}
                  validate
                  onChange={this.validateSamePass}
                  type="password"
                ></ListInput>
              </Col>
              <Col width="10"></Col>
              <Col id="samePass" width="65" style={{ color: "red" }}>
                {this.state.sTextPass}
              </Col>
            </Row>

            <Block>
              <Row className="aligner3">
                <Col width="30"></Col>
                <Col
                  width="35"
                  xlarge="25"
                  large="25"
                  medium="25"
                  small="35"
                  xsmall="35"
                >
                  <Button fill onClick={this.changePassword}>
                    {setLiteral(this.state.lsLiterales, 101070)}
                  </Button>
                </Col>
              </Row>
            </Block>
          </List>
        </LoginScreen>
      </Page>
    );
  }

  changeUser = (user) => {
    if (user.length > 10) {
      user = user.substring(0, 10);
    }

    this.setState({ username: user });
  };

  state = {
    height: 0,
    heightFeatures: 0,
    selectedTab: 1,
    username: "",
    password: "",
    hideEmail: "",
    loginScreenOpened: false,
    configDomain: "",
    configMiApp: "",
    lsLiterales: "",
    idEmpresa: "",
    popupRegistro: "",
    popupUser: false,
    bValidatePass: false,
    sPass: "",
    sTextPass: "",
    Identification: "",
    userInformation: "",
    bSamePass: false,
    popupPassword: false,
    showCloseLogin: "",
    RU: {},
    companyReference: "",
  };

  $$ = Dom7;
  f7router = "";
  // caching = () => {
  //   let version = localStorage.getItem('version');
  //   if (version != packageJson.version) {
  //     if ('caches' in window) {
  //       caches.keys().then((names) => {
  //         // Delete all the cache files
  //         names.forEach(name => {
  //           caches.delete(name);
  //         })
  //       });
  //       // Makes sure the page reloads. Changes are only visible after you refresh.
  //       window.location.reload(true);
  //     }

  //     localStorage.clear();
  //     localStorage.setItem('version', packageJson.version);
  //   }
  // };

  componentDidMount = () => {
    const { f7route, f7router } = this.props;
    const params = f7route.query;

    this.loadNormalMiapp(params);
  };

  loadNormalMiapp = (params) => {
    const { f7route, f7router } = this.props;

    const device = getDevice();
    if (device.android || device.ios) {
      //this.setState({ closeLogin: 'hide' });
    }

    if (window.innerWidth < 800 && this.props.reload) window.location.reload();

    this.f7router = f7router;

    const height = parseInt(window.innerHeight * 0.6) + "px";
    const heightFeatures = parseInt(window.innerHeight * 0.8) + "px";
    this.getConfiguration(params);
    this.setState({ height: height, heightFeatures: heightFeatures });
  };

  getConfiguration = async (params) => {
    const sHost = window.location.hostname;
    const method = "/security/InfoDomain/ConfigByDomain/" + sHost;

    const configuration = await consumeApi("GET", method, "");
    // configuration.id_empresa = "424";
    // configuration.id_idioma = "E";

    //await getTokens(parseInt(configuration.id_empresa));

    this.$$("body").addClass("color-theme-" + configuration.id_empresa);

    this.setState({ configDomain: configuration });

    this.getLiterales();
    this.getConfigMiAppByBranch();

    if (
      params.company &&
      params.idpago &&
      params.idprovider &&
      params.email &&
      params.test
    ) {
      this.paymentOnline(
        params.company,
        params.idpago,
        params.idprovider,
        params.email,
        params.test
      );
    }

    if (this.props.f7route.query.IdCliente) {
      this.getUserByClientId(this.props.f7route.query.IdCliente);
    }
  };
  getLiterales = async () => {
    f7.dialog.preloader(setLiteral(this.state.lsLiterales, 101030));
    const method =
      "/miapp/MiApp/Literal/" +
      this.state.configDomain.id_empresa +
      "/" +
      this.state.configDomain.id_idioma;

    const lsLiterales = await consumeApi("GET", method, "");
    this.setState({ lsLiterales: lsLiterales });
    f7.dialog.close();
  };

  getConfigMiAppByBranch = async () => {
    const method =
      "/miapp/MiApp/ConfigurationByBranch/" +
      this.state.configDomain.id_empresa;
    const lsLiterales = await consumeApi("GET", method, "");
    this.setState({ configMiApp: lsLiterales });
  };

  showChangePass = (e) => {
    e.preventDefault();
    this.setState({
      popupPassword: true,
      loginScreenOpened: false,
      password: "",
    });
    this.$$("#capital").removeClass("charPass");
    this.$$("#number").removeClass("charPass");
    this.$$("#charactes").removeClass("charPass");
  };

  validatePassword = (e) => {
    e.preventDefault();
    const pass = e.target.value;
    var bCapital, bSpecial, bNumber, blength;

    if (capital(pass)) {
      this.$$("#capital").addClass("charPass");
      bCapital = true;
    } else {
      this.$$("#capital").removeClass("charPass");
      bCapital = false;
    }

    if (digit(pass)) {
      this.$$("#number").addClass("charPass");
      bNumber = true;
    } else {
      this.$$("#number").removeClass("charPass");
      bNumber = false;
    }

    if (pass.length >= 8) {
      this.$$("#charactes").addClass("charPass");
      blength = true;
    } else {
      this.$$("#charactes").removeClass("charPass");
      blength = false;
    }

    this.setState({ sPass: pass });

    if (bCapital && bNumber && blength) {
      this.setState({ bValidatePass: true });
    }
  };

  validateSamePass = (e) => {
    if (e.target.value == this.state.sPass) {
      this.setState({ sTextPass: "", bSamePass: true });
    } else {
      this.setState({
        sTextPass: setLiteral(this.state.lsLiterales, 101043),
        bSamePass: false,
      });
    }
  };

  showPassword = (nameInput, nameButton) => {
    var input = this.$$('input[name="' + nameInput + '"]');
    if (input.attr("type") == "password") {
      input.attr("type", "text");
      this.$$("#" + nameButton + "")
        .children(".icon")
        .html("eye");
    } else {
      input.attr("type", "password");
      this.$$("#" + nameButton + "")
        .children(".icon")
        .html("eye_slash");
    }
  };

  changePassword = async () => {
    if (f7.input.validateInputs("#frmChangePass")) {
      if (this.state.bValidatePass && this.state.bSamePass) {
        let username = this.state.username;

        if (validateEmail(username)) username = username.toUpperCase();

        f7.dialog.preloader(setLiteral(this.state.lsLiterales, 101030));

        const mValidateLogin = "/miapp/User/LoginExistent";
        const params = JSON.stringify({
          company: this.state.configDomain.id_empresa,
          login: username,
          applicationType: "1",
        });

        const validateUser = await consumeApi("POST", mValidateLogin, params);

        if (typeof validateUser == "object") {
          const updUser = "/miapp/User/UpdateUser";
          const params = JSON.stringify({
            company: this.state.configDomain.id_empresa,
            login: username,
            clientId: validateUser.clientId,
            password: this.state.sPass,
            option: "2",
            applicationType: "1",
          });
          var updateUser = await consumeApi("POST", updUser, params);

          if (!updateUser.includes("error")) {
            f7.dialog.close();
            f7.dialog.alert(
              "Contraseña cambiada correctamente",
              "¡Éxito!",
              () => {
                this.f7router.navigate("/");
              }
            );
            this.setState({ userInformation: validateUser });
          } else {
            f7.dialog.close();
            f7.dialog.alert(setLiteral(this.state.lsLiterales, 102003), "");
          }
        } else {
          f7.dialog.close();
          f7.dialog.alert(setLiteral(this.state.lsLiterales, 101050), "");
        }
      } else {
      }
    }
  };

  getUserByClientId = async (clientId) => {
    const mGetCliente =
      "/core/Customer/CustomerByClientId/" +
      this.state.configDomain.id_empresa +
      "/" +
      clientId;
    const getClient = await consumeApi("GET", mGetCliente, "");

    if (typeof getClient != "string" && !getClient.includes("error")) {
      this.setState({ Identification: getClient[0].identificationUnique });
      this.validateIdentification(null);
    } else {
      f7.dialog.alert(setLiteral(this.state.lsLiterales, 101050), "");
    }
  };
}
